import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Moment from'moment';
import './adminModelPop.css'
import { userActions } from '../../../actions/index.js';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const initialState={
  userId:'',
  fromDate:null,
  toDate:null,
  vatNoFrom:'',
  accessFromDate:null,
  accessToDate:null,
  errorUserId:"",
  errorfromDate:"",
  errortoDate:"",
  errorAccessFromDate:"",
  errorAccessToDate:"",
  errorVat:"",
  saveStatus:true,
  dialogStatus:''
}
class AdminModelPop extends Component {

constructor(props) {
  super(props);
  this.state = initialState
this.save =this.save.bind(this);
this.onFromDateChange=this.onFromDateChange.bind(this);
this.onToDateChange=this.onToDateChange.bind(this)
this.onAccessFromDate=this.onAccessFromDate.bind(this)
this.onAccessToDate=this.onAccessToDate.bind(this)
this.checkDates = this.checkDates.bind(this);
}
componentWillReceiveProps(nextProps) {
console.log('Props Receve Data:',nextProps);
this.setState({dialogStatus:nextProps.dialogFor});
if(nextProps.dialogFor==='EDIT'){
  this.setState({userId:nextProps.selectedEditData.userId});
  this.setState({fromDate:nextProps.selectedEditData.searchFromDate});
  this.setState({toDate:nextProps.selectedEditData.searchToDate});
  this.setState({vatNoFrom:nextProps.selectedEditData.vatNumberFrom});
  this.setState({accessFromDate:nextProps.selectedEditData.accessFromDate});
  this.setState({accessToDate:nextProps.selectedEditData.accessToDate});
}else{
  this.setState(initialState);
}
const reqBody={
  "size":10,
  "index":0,
  "sortColumn":"userId",
  "sortOrder":"ASC"
}
if(nextProps.createStatus==='Auditor record created successfully'){
  this.props.close();
  confirmAlert({
    title:'ADD Auditor Confirmation alert box',
    message:  this.props.createStatus,
    buttons: [
        {
            label: 'Ok',
            onClick: () => {
              this.props.dispatch(userActions.auditorList("/auditorData/auditors",reqBody));
            }
        },
        {
            label: 'Cancel'
        }
    ]
})
}else if(nextProps.createStatus==='Auditor record updated successfully'){
  this.props.close();
  confirmAlert({
    title:'Update auditor Confirmation alert box',
    message:  this.props.createStatus,
    buttons: [
        {
            label: 'Ok',
            onClick: () => {
              this.props.dispatch(userActions.auditorList("/auditorData/auditors",reqBody));
            }
        },
        {
            label: 'Cancel'
        }
    ]
})

}
 
}
close = () => {
  this.setState(initialState);
  this.props.close()
};
save = (e) => {
  console.log('SaveEvent:',this.state);
  if(this.state.userId==""){
    this.setState({errorUserId:"Please Enter User Id"});
    this.state.saveStatus=false;
  } if(this.state.fromDate==null){
    this.setState({errorfromDate:"Please Enter From Date"})
    this.state.saveStatus=false;
  } if(this.state.toDate==null){
    this.setState({errortoDate:"Please Enter To Date"})
    this.state.saveStatus=false;
  }if(this.state.vatNoFrom===''){
    this.setState({errorVat:'Please Enter Vat Number'});
    this.state.saveStatus=false;
  }if(this.state.accessFromDate==null || this.state.accessFromDate ==='Invalid date' ){
    this.setState({errorAccessFromDate:"Please Enter Access From Date"})
    this.state.saveStatus=false;
  } if(this.state.accessToDate==null || this.state.accessToDate==='Invalid date' ){
    this.setState({errorAccessToDate:"Please Enter Access To date"})
    this.state.saveStatus=false;
   }
  else if(this.state.userId!=="" && this.state.fromDate!==null
   && this.state.toDate!==null && this.state.vatNoFrom!=='' && this.state.accessFromDate!==null
   && this.state.accessToDate!==null){
     this.state.saveStatus=true;
   }
const auditor={
  "userId":this.state.userId,
  "searchFromDate":moment(this.state.fromDate).format('YYYY-MM-DD'),
  "searchToDate":moment(this.state.toDate).format('YYYY-MM-DD'),
  "accessFromDate":moment(this.state.accessFromDate).format('YYYY-MM-DD'),
  "accessToDate":moment(this.state.accessToDate).format('YYYY-MM-DD'),
  "vatNumberFrom":this.state.vatNoFrom
}

console.log("Auditor:",auditor);
console.log('DialogStatus:',this.state.dialogStatus +'StatusSave:',this.state.saveStatus);
if(this.props.dialogFor==='ADD'){
     if(this.state.saveStatus){
    this.props.dispatch(userActions.auditorCreate("/auditorData/create",auditor));
    console.log('Save Props:',this.props);
     }
  }else{
    if(this.state.saveStatus){
    this.props.dispatch(userActions.updateAuditor("/auditorData/update/" + this.props.selectedEditData.id,auditor))
    }
  }


};
onAuditorChange = e =>{
    this.setState({[e.target.name]:e.target.value});
console.log('EvenHandling:',this.state.userId);
this.setState({errorUserId:""});
//this.setState({errorVat:''});
}
onVatChange = e =>{
  this.setState({[e.target.name]:e.target.value});
  this.setState({errorVat:''});
}
checkUserValidation= e =>{
//let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let emailRegex=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)+$/ ;
console.log('Status:',emailRegex.test(this.state.userId));
 if(emailRegex.test(this.state.userId)){
   this.setState({errorUserId:''});
 }else{
  this.setState({errorUserId:"Please enter valid userId like abc.abc@TMME"});
 
 }
}
checkDates(fDate, tDate) {
  if (fDate && tDate) {
    if ( moment(tDate).isSame(moment(fDate)) ) {
          this.setState({ toDate: null, errortoDate: "To date should be greater than From date" });
      } else if (tDate < fDate) {
          this.setState({ toDate: null, errortoDate: "To date should be greater than From date" });
      }
  }
}

onFromDateChange(fromDate){
  console.log('Fromdate-------',fromDate);
  this.setState({fromDate});
  this.setState({errorfromDate:''})
  this.checkDates(fromDate,this.state.toDate);
}
onToDateChange(toDate){
  console.log('Todate-------',toDate);
  this.setState({toDate});
  this.setState({errortoDate:''})
  this.checkDates(this.state.fromDate,toDate);
}
onAccessFromDate(accessFromDate){
  this.setState({accessFromDate});
  this.setState({errorAccessFromDate:''});
}
onAccessToDate(accessToDate){
  this.setState({accessToDate})
  this.setState({errorAccessToDate:''});
}

render() {
  return (
    <Modal show={this.props.opendialog} onHide={this.close}>
      <Modal.Header closeButton>
        <Modal.Title>
         {this.props.dialogFor}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
    <form>
      <div className='form-group'>
      <div className='row'>
      <label className="col-md-4">User Id:</label>
      <input
      className="form-control col-md-6"
      placeholder="user Id"
      type="email"
      name="userId"
      //pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
      value={this.state.userId}
      onChange={this.onAuditorChange}
      onBlur={this.checkUserValidation}
      />
      </div>
      <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
      <p className="text-danger alert-control col-md-12">{this.state.errorUserId}</p>
      </div>
      </div>
      </div>
      <div className='form-group'>
      <div className='row'>
      <label className="col-md-4">Invoice From Date:</label>
       <DatePicker className='form-control col-md-11'
       placeholderText='Invoice From Date'
       dateFormat="DD/MM/YYYY" 
       //name="formDate"
      selected={this.state.fromDate?Moment(this.state.fromDate):null}
       onChange={this.onFromDateChange}
       />
       </div>
       <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
       <p className="text-danger alert-control">{this.state.errorfromDate}</p>
       </div>
       </div>
        </div>
      <div className='form-group'>
      <div className='row'>
      <label className="col-md-4">Invoice To Date:</label>
       <DatePicker className='form-control col-md-11'
       placeholderText='Invoice To Date'
       dateFormat="DD/MM/YYYY" 
       //name="formDate"
       selected={this.state.toDate?Moment(this.state.toDate):null}
       onChange={this.onToDateChange}
       />
       </div>
       <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
       <p className="text-danger alert-control">{this.state.errortoDate}</p>
       </div>
       </div>
        </div>
        <div className='form-group'>
        <div className='row'>
        <label className="col-md-4">Vat Supplier No.</label>
        <input className="form-control col-md-6"
        placeholder="Vat Supplier Number"
        name="vatNoFrom"
        value={this.state.vatNoFrom}
       onChange={this.onVatChange}
        />
        </div>
        <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
      <p className="text-danger alert-control">{this.state.errorVat}</p>
      </div>
      </div>
        </div>
        <div className='form-group'>
        <div className='row'>
        <label className="col-md-4">Access From Date:</label>
        <DatePicker className='form-control col-md-11'
        placeholderText='Access From Date'
        dateFormat="DD/MM/YYYY"
        selected={this.state.accessFromDate?Moment(this.state.accessFromDate):null}
        onChange={this.onAccessFromDate}
        />
        </div>
        <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
      <p className="text-danger alert-control">{this.state.errorAccessFromDate}</p>
      </div>
      </div>
          </div>
          <div className='form-group'>
          <div className='row'>
        <label className="col-md-4">Access To Date:</label>
        <DatePicker className='form-control col-md-11'
        placeholderText='Access To Date'
        dateFormat="DD/MM/YYYY"
        showDisabledMonthNavigation
        selected={this.state.accessToDate?Moment(this.state.accessToDate):null}
        minDate={this.state.accessFromDate}
        maxDate={Moment(this.state.accessFromDate).add('days',14)}
        disabledKeyboardNavigation 
        onChange={this.onAccessToDate}
        />
        </div>
        <div className="row">
      <div className="col-md-4"></div>
      <div className="col-md-7">
      <p className="text-danger alert-control">{this.state.errorAccessToDate}</p>
      </div>
      </div>
          </div>
      </form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button" variant="secondary" onClick={this.close}>
          Close
        </Button>
        {this.props.dialogFor==='ADD' ?<Button className="button" variant="secondary" onClick={this.save}>
          Save
        </Button>:
        <Button className="button" variant="secondary" onClick={this.save}>
          Update
        </Button>}
      </Modal.Footer>
    </Modal>
  );
}
}
const mapStateToProps =state =>{
  const {blocking,createStatus}=state.searchData;
  return{
    blocking,createStatus
  }
}
export default withRouter(connect(mapStateToProps)(AdminModelPop));
//export default AdminModelPop;